goog.provide("shadow.js.shim.module$$mui$material$Chip");
goog.provide("module$shadow_js_shim_module$$mui$material$Chip");
shadow.js.shim.module$$mui$material$Chip = shadow.js.nativeProvides["@mui/material/Chip"] = shadow$bridge("@mui/material/Chip");
module$shadow_js_shim_module$$mui$material$Chip.default = shadow.js.shim.module$$mui$material$Chip;
